import { API } from '../../config/api';
import { DELETE, GET, POST, PUT } from '../../utils/apicalls';
import { Button, Card, Form, Input, notification, Select, Switch, Upload } from 'antd';
import AWS from 'aws-sdk';
import { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import stock from '../../assets/stockout.png'



function UpdateClientProduct() {
  const user = useSelector((state: any) => state.user);

  // const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const [categoryData, setCategoryData] = useState<any>([]);
  const navigate = useNavigate();
  const [subcategoryData, setsubCategoryData] = useState<any>([]);
  const [variants, setVariants] = useState<any[]>([]);

  const { id } = useParams();
  const [productImage1, setProductImage1] = useState<string | null>(null);
  const [productImage2, setProductImage2] = useState<string | null>(null);
  const [productImage3, setProductImage3] = useState<string | null>(null);
  const [productImage4, setProductImage4] = useState<string | null>(null);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  interface AwsData {
    accessKeyId?: string;
    secretAccessKey?: string;
    region?: string;
    [key: string]: any;
  }
  const [awsData, setawsData] = useState<AwsData>({});
  const s3 = new AWS.S3({
    accessKeyId: awsData.accessKeyId,
    secretAccessKey: awsData.secretAccessKey,
    region: awsData.region,
  });
  const fetchawsDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
      if (response && response.accessKeyId) {
        setawsData(response); // Not response.data
      } else if (response?.data?.accessKeyId) {
        setawsData(response.data); // If using Axios-style
      } else {
        console.warn("AWS credentials not found in response", response);
      }
    } catch (error) {
      console.error("Failed to fetch AWS credentials", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
      AWS.config.update({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
      });
    }
  }, [awsData]);
  useEffect(() => {
    fetchawsDetails();
  }, []); const S3_BUCKET = awsData?.bucketName;

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.LISTING_GET_CATEGORY, {});
      setCategoryData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchVariants = async () => {
    try {
      setIsLoading(true);

      let api = API.GET_BY_PRODUCTID_VARIANT + id;
      const response: any = await GET(api, {});
      const payload = response?.data ?? response ?? [];
      // ensure array
      const variantsData = Array.isArray(payload) ? payload : payload?.variants ?? [];

      setVariants(variantsData);
      // set into form list so Form.List will render initial values
      form.setFieldsValue({
        variants: variantsData,
      });

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchCategories();
    fetchOneProduct();
    fetchVariants()
  }, []);

  const handleFileChange = (info: any, field: string) => {
    if (info.file.status === "done") {
      const fileUrl = info.file.response?.location || info.file.response?.url;
      if (fileUrl) {
        if (field === "productImage1") setProductImage1(fileUrl);
        if (field === "productImage2") setProductImage2(fileUrl);
        if (field === "productImage3") setProductImage3(fileUrl);
        if (field === "productImage4") setProductImage4(fileUrl);

        form.setFieldsValue({ [field]: fileUrl });
      }
    } else if (info.file.status === "error") {
      notification.error({ message: "File upload failed!" });
    }
  };

  const getUploadProps = (field: string) => ({
    name: "file",
    headers: {
      "x-amz-acl": "public-read",
      "Content-Type": "multipart/form-data",
    },
    onChange: (info: any) => handleFileChange(info, field),
    customRequest: async (options: any) => {
      const { onSuccess, onError, file } = options;
      const params = {
        Bucket: S3_BUCKET,
        Key: `product/${field}/${file.name}`,
        Body: file,
        // ACL: "public-read",
        ContentType: file.type,
      };

      s3.upload(params, (err: any, data: any) => {
        if (err) {
          onError(err);
          notification.error({ message: "File upload failed!" });
        } else {
          if (field === "productImage1") setProductImage1(data.Location);
          if (field === "productImage2") setProductImage2(data.Location);
          if (field === "productImage3") setProductImage3(data.Location);
          if (field === "productImage4") setProductImage4(data.Location);

          form.setFieldsValue({ [field]: data.Location });
          onSuccess(data);
          notification.success({ message: "File uploaded successfully!" });
        }
      });
    },
  });

  const fetchOneProduct = async () => {
    try {
      setIsLoading(true);
      let api = API.GET_ONE_PRODUCT + id;
      const response: any = await GET(api, {});
      // setData(response?.data);
      form.setFieldsValue(response?.data);
      if (response?.data) {
        setProductImage1(response.data.productImage1);
        setProductImage2(response.data.productImage2);
        setProductImage3(response.data.productImage3);
        setProductImage4(response.data.productImage4);

        // Set isOutOfStock based on product data
        const stockStatus = response.data.stock_product;
        setIsOutOfStock(stockStatus === 'Out of Stock');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_PRODUCT_VARIANT}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data?.success || data?.status) {
        notification.success({ message: data.message || "Variant deleted successfully!" });
        // Refresh variants after delete
        fetchVariants();
      } else {
        notification.error({
          message: data?.message || "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const Updateproduct = async (values: any) => {
    try {
      let obj = {
        productTitle: values.productTitle,
        productImage1,
        productImage2,
        productImage3,
        productImage4,
        descriptionProduct: values.descriptionProduct,
        brand: values.brand,
        color: values.color,
        gender: values.gender,
        size: values.size,
        shipping: values.shipping,
        Price: Number(values.Price),
        category_id: values.category_id,
        clientId: user.id,
        Subcategory_id: values.Subcategory_id,
        stock_product: isOutOfStock ? 'Out of Stock' : 'In Stock',
      };

      setIsLoading(true);
      let api = API.UPDATE_PRODUCT + id;
      const postRequest: any = await PUT(api, obj);
      if (postRequest) {
        // 🟢 2. Update the product variants next
        if (values.variants && values.variants.length > 0) {
          const variantResponse = await PUT(`${API.UPDATE_PRODUCT_VARIANT}${id}`, values.variants);

          if (variantResponse) {
            notification.success({
              message: "Product and variants updated successfully!",
            });
          } else {
            notification.warning({
              message: "Product updated, but variant update failed!",
            });
          }
        }
        notification.success({ message: "Product updated successfully!" });
        form.resetFields();
        setProductImage1(null);
        setProductImage2(null);
        setProductImage3(null);
        setProductImage4(null);
        fetchCategories();
        fetchOneProduct();
        navigate(-1);
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const filtersubCategoryData = async (categoryId: number) => {
    try {
      setIsLoading(true);
      const api = API.FILTER_SUBCATEGORY;
      const response: any = await POST(api, { category_id: categoryId });

      if (response?.data) {
        setsubCategoryData(response?.data); // Update subcategories
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <h1>Update Product page</h1>
      <Card>
        <Form form={form} onFinish={Updateproduct} layout="vertical">
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="productTitle"
                label="Product Title"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="brand"
                label="Brand"
              // rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="shipping"
                label="shipping"
              // rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="color"
                label="Color"
              // rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="size" label="size"
              //  rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select Gender">
                  <Select.Option value="male">Male</Select.Option>
                  <Select.Option value="female">Female</Select.Option>
                  <Select.Option value="other">Other</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="Price"
                label="Price"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="category_id"
                label="Category"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Select a category"
                  onChange={(value) => {
                    form.setFieldsValue({ subCategory: undefined }); // Reset subcategory
                    filtersubCategoryData(value); // Fetch subcategories
                  }}
                  loading={isLoading}
                >
                  {categoryData?.map((category: any) => (
                    <Select.Option key={category.id} value={category.id}>
                      {category.categoryTitle}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>


            </Col>
            <Col span={8}>
              <Form.Item
                name="Subcategory_id"
                label="SubCategory"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select a subcategory" loading={isLoading}>
                  {subcategoryData?.map((sub: any) => (
                    <Select.Option key={sub.id} value={sub.id}>
                      {sub.SubcategoryTitle}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

            </Col>
            <Col span={8}>
              <Form.Item
                name="descriptionProduct"
                label="Description"
                rules={[{ required: true }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="productImage1" label="Product Image 1">
                <Upload {...getUploadProps("productImage1")}>
                  <Button>Upload</Button>
                </Upload>
                {productImage1 && (
                  <img
                    src={productImage1}
                    alt="Uploaded"
                    className="w-24 h-24 mt-2"
                    style={{ width: "20%", height: "20vh", objectFit: "cover" }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="productImage2" label="Product Image 2">
                <Upload {...getUploadProps("productImage2")}>
                  <Button>Upload</Button>
                </Upload>
                {productImage2 && (
                  <img
                    src={productImage2}
                    alt="Uploaded"
                    className="w-24 h-24 mt-2"
                    style={{ width: "20%", height: "20vh", objectFit: "cover" }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="productImage3" label="Product Image 3">
                <Upload {...getUploadProps("productImage3")}>
                  <Button>Upload</Button>
                </Upload>
                {productImage3 && (
                  <img
                    src={productImage3}
                    alt="Uploaded"
                    className="w-24 h-24 mt-2"
                    style={{ width: "20%", height: "20vh", objectFit: "cover" }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="productImage4" label="Product Image 4">
                <Upload {...getUploadProps("productImage4")}>
                  <Button>Upload</Button>
                </Upload>
                {productImage4 && (
                  <img
                    src={productImage4}
                    alt="Uploaded"
                    className="w-24 h-24 mt-2"
                    style={{ width: "20%", height: "20vh", objectFit: "cover" }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="stock_product"
                label="Stock Product"
              >
                <>
                  <div style={{ marginTop: 8 }}>
                    <Switch
                      checked={isOutOfStock}
                      onChange={(checked) => setIsOutOfStock(checked)}
                    />{' '}
                    <span style={{ marginLeft: 8 }}>
                      {isOutOfStock ? 'Out of Stock' : 'In Stock'}
                    </span>
                  </div>

                  {isOutOfStock && (
                    <div style={{ marginTop: 10 }}>
                      <img
                        width={100}
                        src={stock}
                        alt="Sold Out"
                      />
                    </div>
                  )}
                </>
              </Form.Item>
            </Col>

          </Row>
          <Col span={8}>
            <h3>Product Variants</h3>

            <Form.List name="variants">
              {(fields, { add, remove }) => (
                <>

                  {fields.map(({ key, name, ...restField }) => (

                    <Row gutter={16} key={key} align="middle">

                      <Col span={8}>

                        <Form.Item
                          {...restField}
                          name={[name, "variantName"]}
                          label="Variant Name"
                          rules={[{ required: true, message: "Enter variant name" }]}
                        >
                          <Input placeholder="e.g. XL, 1kg" />
                        </Form.Item>
                      </Col>

                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, "variantprice"]}
                          label="Variant Price"
                          rules={[{ required: true, message: "Enter price" }]}
                        >
                          <Input type="number" placeholder="Enter price" />
                        </Form.Item>
                      </Col>

                      <Col span={4}>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const variantId = getFieldValue(["variants", name, "id"]);
                            return (
                              <Button
                                danger
                                onClick={() => {
                                  if (variantId) {
                                    handleDelete(variantId);
                                  } else {
                                    remove(name); // if not yet saved in DB
                                  }
                                }}
                              >
                                Remove
                              </Button>
                            );
                          }}
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}

                  <Button type="dashed" onClick={() => add()} block>
                    + Add Variant
                  </Button>
                </>
              )}
            </Form.List>

          </Col>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  )
}

export default UpdateClientProduct
